import React, { useCallback, useState } from "react";

import cx from "classnames";

import { KeyboardNavigation } from "~/common";
import { ReactComponent as AskFellowIconActive } from "~/nav/icons/ask-fellow-filled.svg";
import { useAskFellowOpenPanelFromSearch } from "~/nav/panels/AskFellow/AskFellowHooks";
import { Button } from "~/ui";

import styles from "./JumpToResult.module.css";

interface JumpToAskFellowProps {
	query: string | null;
	onSelect?: () => void;
}

export default function JumpToAskFellow({ query, onSelect }: JumpToAskFellowProps) {
	const [focused, setFocused] = useState(false);

	const openPanelWithPreFilledQuery = useAskFellowOpenPanelFromSearch();

	const onClick = useCallback(() => {
		openPanelWithPreFilledQuery(query);
		if (onSelect) {
			onSelect();
		}
	}, [openPanelWithPreFilledQuery, query, onSelect]);

	const focus = useCallback(() => setFocused(true), []);
	const unfocus = useCallback(() => setFocused(false), []);

	const resultContent = (
		<>
			<div className={styles.askFellowIcon}>
				<AskFellowIconActive />
			</div>
			<span>Ask Fellow {query ? <strong>&quot;{query}&quot;</strong> : "about your meetings"}</span>
		</>
	);

	return (
		<KeyboardNavigation.Focusable onFocus={focus} onBlur={unfocus} onEnterDown={onClick}>
			<Button className={cx(styles.wrapper, { [styles.focused]: focused })} onClick={onClick}>
				{resultContent}
			</Button>
		</KeyboardNavigation.Focusable>
	);
}
